module.exports = angular.module('eatself').component('uploadFile',{
	bindings: {
		type: '<',
		upload: '&',
		previewUrl: '<',
		needsVerso: '<',
		previewVersoUrl: '<',
		send: '&',
		validity_date: '<',
	},
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
		inject: ['$element','$attrs'],
		methods: {
			click(selector) {
				$(selector, this.$element).click();
			},
			getName(url) {
				let name = url.match(/__(.*)$/);
				return name && name[0];
			},
			do_upload(type, file, verso) {
				if (!file) {
					return;
				}
				if (!verso) {
					this.uploading = true;
				} else {
					this.uploadingVerso = true;
				}
				this.upload({file, type, verso})
				.finally(_ => {
					if (!verso) {
						this.uploading = false;
					} else {
						this.uploadingVerso = false;
					}
				})
			},
			do_send() {
				if (moment().isAfter(this.validity_date)) {
					this.errorMsg = "La date d'expiration est passée";
					return;
				}
				this.errorMsg = "";
				this.sending = true;
				this.send({type: this.type, validity_date: this.validity_date})
				.catch((err) => this.errorMsg = err.data.msg)
				.finally(_ => this.sending = false);
			},
		}
	}),
	template: `
	<style>
		.flex-horizontal {
			display: flex;
			align-items: center;
			white-space: nowrap;
		}
		.pad {
			margin: 5px;
		}
	</style>
	<div class="flex-horizontal">
		<div>
			<div class="flex-horizontal">
				<input type="file" id="file-input" style="display: none" ngf-select="vm.do_upload(vm.type, $file)" />
				<action-button class="pad" type="edit" ng-click="vm.click('#file-input')">
					<i class="icone icone-editer"></i>
					<i class="loading" ng-show="vm.uploading"></i>
				</action-button>
				<a ng-if="vm.previewUrl" target="_blank" class="btn btn-info button-height pad" ng-href="{{vm.previewUrl}}" title="{{vm.getName(vm.previewUrl)}}">
					<i class="glyphicon glyphicon-eye-open"></i>
					<span ng-if="!vm.needsVerso">Visualiser</span>
					<span ng-if="vm.needsVerso">Recto</span>
				</a>
			</div>
			<div class="flex-horizontal" ng-if="vm.needsVerso">
				<input type="file" id="file-input_verso" style="display: none" ngf-select="vm.do_upload(vm.type, $file, true)" />
				<action-button class="pad" type="edit" ng-click="vm.click('#file-input_verso')">
					<i class="icone icone-editer"></i>
					<i class="loading" ng-show="vm.uploadingVerso"></i>
				</action-button>
				<a ng-if="vm.previewVersoUrl" target="_blank" class="btn btn-info button-height pad" ng-href="{{vm.previewVersoUrl}}" title="{{vm.getName(vm.previewVersoUrl)}}">
					<i class="glyphicon glyphicon-eye-open"></i> Verso
				</a>
			</div>
		</div>
		<div>
			<div class="flex-horizontal" style="align-items: flex-end;">
				<div ng-if="vm.needsVerso" class="validity_date pad">
					<label for="">Date d'expiration</label>
					<div class="input-group">
						<input type="text" style="min-width: 100px" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-click="vm.isCalendarOpen = !vm.isCalendarOpen"
								ng-model="vm.validity_date" is-open="vm.isCalendarOpen" autocomplete="off"
								clear-text="Effacer" close-text="OK" current-text="Aujourd'hui" />
						<span class="input-group-btn">
							<button class="btn btn-default" ng-click="vm.isCalendarOpen = !vm.isCalendarOpen"><i class="glyphicon glyphicon-calendar"></i></button>
						</span>
					</div>
				</div>
				<a ng-if="vm.$attrs.send" class="btn btn-primary button-height pad" ng-click="vm.do_send()">
					<i class="glyphicon glyphicon-cloud-upload"></i> Envoyer
					<i class="loading" ng-show="vm.sending"></i>
				</a>
			</div>
			<div class="text-danger pad" style="white-space: normal;">{{vm.errorMsg}}</div>
		</div>
	</div>
	`,
})
